module.exports = __webpack_public_path__ + "media/images/lb/922-3fc11e562aaaa1b8d7559b430df5e46f.svg";